module.exports = __webpack_public_path__ + "static/media/prototype_loading.bd830f19.png";